import { Injectable } from '@angular/core';
import { ObjectUploadResponse, PagedList, PromoBannerModel, PromoBannerResourceService, SavePromoBannerRequest, SaveResult } from 'hx-services';
import { firstValueFrom } from 'rxjs';

@Injectable({providedIn: 'root'})
export class PromoBannerService {
  constructor(
    private promoBannerResource: PromoBannerResourceService,
  ) {
  }

  getFileUploadUrl(name: string): string {
    return `/api/vn/promo-banners/files/${name}`;
  }

  removeFile(name: string, fileName: string) {
    return firstValueFrom(this.promoBannerResource.deletePromoBannerFileByName(name, fileName));
  }

  getPromoBanners(params?: {
    page?: number;
    limit?: number;
    sort?: string[];
    cityId?: number;
  }): Promise<PagedList<PromoBannerModel>> {
    return firstValueFrom(this.promoBannerResource.getPromoBanners(
      params?.cityId,
      params?.limit,
      params?.page,
      params?.sort,
    ));
  }

  getPromoById(id: number): Promise<PromoBannerModel> {
    return firstValueFrom(this.promoBannerResource.getPromoBannerById(id));
  }

  savePromo(req: SavePromoBannerRequest): Promise<SaveResult> {
    return firstValueFrom(this.promoBannerResource.savePromoBanner(req));
  }

  removePromo(id: number): Promise<void> {
    return firstValueFrom(this.promoBannerResource.removePromoBannerById(id));
  }

  getPromoImageUrls(name: string): Promise<ObjectUploadResponse[]> {
    return firstValueFrom(this.promoBannerResource.getPromoBannerFilesByName(name));
  }

}
